import { render, staticRenderFns } from "./Screendata.vue?vue&type=template&id=10531c21"
import script from "./Screendata.vue?vue&type=script&lang=js"
export * from "./Screendata.vue?vue&type=script&lang=js"
import style0 from "./Screendata.vue?vue&type=style&index=0&id=10531c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports